import { useParams } from 'react-router-dom';
import { useBookings } from '../../shared/booking/BookingsContext';
import BookingDetailsPage from '../../shared/booking/BookingDetailsPage';
import { flightRefund } from './data';
import FlightSummary from './FlightSummary';
import FlightBookingServices from './FlightBookingServices';

export default function FlightBookingDetails() {
  const { bookingId } = useParams();
  const { getBooking } = useBookings();
  const booking = getBooking(bookingId);

  return (
    <BookingDetailsPage
      module="flights"
      Summary={FlightSummary}
      refLabel="Airline PNR"
      refund={flightRefund}
      extraDetails={<FlightBookingServices booking={booking} />}
      policy={[
        'Cancellation charges depend on the fare type selected (Saver, Flexi or Super Flexi).',
        'A Trawtel service fee of ₹299 per booking applies on cancellation.',
        'Cancellations are not allowed within 2 hours of departure — please contact the airline.',
        'Refunds are credited to the original payment method within 5–7 working days.',
      ]}
    />
  );
}
